var _path, _line, _line2, _path2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 80,
    viewBox: "0 0 88 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.1211 42.1213C88.2927 40.9497 88.2927 39.0503 87.1211 37.8787L68.0292 18.7868C66.8576 17.6152 64.9581 17.6152 63.7866 18.7868C62.615 19.9584 62.615 21.8579 63.7866 23.0294L80.7571 40L63.7866 56.9706C62.615 58.1421 62.615 60.0416 63.7866 61.2132C64.9581 62.3848 66.8576 62.3848 68.0292 61.2132L87.1211 42.1213ZM29.7271 43L84.9998 43V37L29.7271 37V43Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 40,
    x2: 29.6364,
    y2: 40,
    stroke: "currentColor",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 14,
    x2: 52,
    y2: 18,
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 72V8H48V16H56V6C56 2.68629 53.3137 0 50 0H6C2.68629 0 0 2.68629 0 6V74C0 77.3137 2.68629 80 6 80H50C53.3137 80 56 77.3137 56 74V63H48V72H8Z",
    fill: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 62,
    x2: 52,
    y2: 66,
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.817bfdfc810719f9ba13424a40101ef3.svg";
export { ForwardRef as ReactComponent };